import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'career-guidance',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class CareerGuidanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
